import { render, staticRenderFns } from "./BmDetail.vue?vue&type=template&id=fbd127c4&scoped=true&"
import script from "./BmDetail.vue?vue&type=script&lang=js&"
export * from "./BmDetail.vue?vue&type=script&lang=js&"
import style0 from "./BmDetail.vue?vue&type=style&index=0&id=fbd127c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd127c4",
  null
  
)

export default component.exports